namespace TabAurous.OMS {
    export interface DesignRow {
        DesignId?: number;
        DesignCode?: string;
        DesignName?: string;
        ItemTypeId?: number;
        ProductTypeId?: number;
        AttributeId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        ImageName?: string;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        Image4?: string;
        Image5?: string;
        Image6?: string;
        Image7?: string;
        Image8?: string;
        Video1?: string;
        Video2?: string;
        ServerDate?: string;
        CreationDate?: string;
        Remarks?: string;
        MappingId?: number;
        MappingCode?: string;
        IsDisabled?: boolean;
        HasBom?: boolean;
        Volume?: number;
        Volume1?: number;
        Volume2?: number;
        Iteration?: string;
        ProductTypeName?: string;
        Attribute?: string;
        ItemType?: string;
        CategoryId?: number;
        CategoryName?: string;
        CategoryCode?: string;
        SubCategoryId?: number;
        SubCategoryName?: string;
        BrandId?: number;
        CollectionId?: number;
        SuperTypeId?: number;
        ProductSizeId?: number;
        ProductSizeName?: string;
        MetalId?: number;
        KaratId?: number;
        MetalColorId?: number;
        KaratName?: string;
        MetalColorName?: string;
        Purity?: number;
        MinPurity?: number;
        MaxPurity?: number;
        StdPurity?: number;
        ShapeId?: number;
        StoneColorId?: number;
        QualityId?: number;
        StoneSizeId?: number;
        SieveId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        GroupSieveName?: string;
        QualityName?: string;
        ShapeName?: string;
        BOMDetails?: DesignBOMRow[];
        IsConfigurable?: boolean;
        ZProofId?: string;
    }

    export namespace DesignRow {
        export const idProperty = 'DesignId';
        export const nameProperty = 'DesignCode';
        export const localTextPrefix = 'OMS.Design';
        export const deletePermission = 'Designs:Delete';
        export const insertPermission = 'Designs:Add';
        export const readPermission = '*';
        export const updatePermission = 'Designs:Edit';

        export declare const enum Fields {
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            DesignName = "DesignName",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            AttributeId = "AttributeId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            ImageName = "ImageName",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            Image4 = "Image4",
            Image5 = "Image5",
            Image6 = "Image6",
            Image7 = "Image7",
            Image8 = "Image8",
            Video1 = "Video1",
            Video2 = "Video2",
            ServerDate = "ServerDate",
            CreationDate = "CreationDate",
            Remarks = "Remarks",
            MappingId = "MappingId",
            MappingCode = "MappingCode",
            IsDisabled = "IsDisabled",
            HasBom = "HasBom",
            Volume = "Volume",
            Volume1 = "Volume1",
            Volume2 = "Volume2",
            Iteration = "Iteration",
            ProductTypeName = "ProductTypeName",
            Attribute = "Attribute",
            ItemType = "ItemType",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            CategoryCode = "CategoryCode",
            SubCategoryId = "SubCategoryId",
            SubCategoryName = "SubCategoryName",
            BrandId = "BrandId",
            CollectionId = "CollectionId",
            SuperTypeId = "SuperTypeId",
            ProductSizeId = "ProductSizeId",
            ProductSizeName = "ProductSizeName",
            MetalId = "MetalId",
            KaratId = "KaratId",
            MetalColorId = "MetalColorId",
            KaratName = "KaratName",
            MetalColorName = "MetalColorName",
            Purity = "Purity",
            MinPurity = "MinPurity",
            MaxPurity = "MaxPurity",
            StdPurity = "StdPurity",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            QualityId = "QualityId",
            StoneSizeId = "StoneSizeId",
            SieveId = "SieveId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            GroupSieveName = "GroupSieveName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            BOMDetails = "BOMDetails",
            IsConfigurable = "IsConfigurable",
            ZProofId = "ZProofId"
        }
    }
}
